export default "__VITE_ASSET__e7f91bbe__"